import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeCompanyList } from './normalize';

export const fetchCompanyList = createProvider(api.fetchCompanyList)
  .andThen((res) => normalizeCompanyList(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
